import type { IconButtonProps } from '@mui/material'
import { IconButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import type { FunctionComponent } from 'react'

const StyledIconButton = withStyles((theme) => ({
  root: {
    borderRadius: 0,
    border: 2,
    borderStyle: 'solid',
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
  },
}))(IconButton)

export const SimpleIconButton: FunctionComponent<
  React.PropsWithChildren<IconButtonProps>
> = ({ children, className = '', ...props }) => {
  return (
    <StyledIconButton
      className={`focus:outline-none ${className}`.trim()}
      {...props}
    >
      {children}
    </StyledIconButton>
  )
}
